let countries = ['Pakistan', 'India']
let placeData = {
    'Pakistan': ['Karachi', 'Lahore', 'Hyderabad', 'Sukkur', 'Islamabad', 'Faisalabad', 'Larkana',
        'Chitral', 'Kalash', 'Neelum'],
    'India': ['Assam', 'Agra', 'Himalaya', 'Kedarnath', 'Laal Qila', 'Hyderabad']
}


export { countries, placeData }